document.addEventListener('turbolinks:load', () => {

  Array.from(document.querySelectorAll('.delay')).forEach(element => {
    const waitString: string = element.getAttribute('data-wait');
    const wait: number = waitString ? Number(waitString) : 1000;
    const idString: string = (element.getAttribute('data-observer') || '').replace('#', '');
    const trigger: Element = document.getElementById(idString);
    const rootMargin: string = element.getAttribute('data-root-margin') || '0px';

    function observerCallback(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
      entries.forEach((entry: IntersectionObserverEntry, i: number) => {
        if (!entry.isIntersecting) { return; }
        setTimeout(() => {
          element.classList.add('delay--display');
          setTimeout(() => { element.classList.add('delay--show'); }, 100);
        }, wait);
        observer.unobserve(trigger);
      });
    }

    if (trigger) {
      const observer = new IntersectionObserver(observerCallback, { rootMargin });
      observer.observe(trigger);
    }
  });

});
